'use client'

import { useCallback, useEffect, useState } from 'react'

import { ConversationLinkActions } from '@marketplace-web/messaging/conversation-messaging-data'
import { Screen } from 'constants/tracking/screens'

import ElectronicsVerificationBuyerModal from '../ElectronicsVerificationBuyerModal'

const ElectronicsVerificationInfoLink = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClose = () => setIsModalOpen(false)

  const handleModalOpen = useCallback(() => {
    setIsModalOpen(true)
  }, [setIsModalOpen])

  useEffect(() => {
    const handleShipmentLinkClick = event => {
      const element = event.target as HTMLElement

      if (!element.classList.contains(ConversationLinkActions.ReactElectronicsVerificationInfoLink))
        return

      event.preventDefault()
      handleModalOpen()
    }

    document.body.addEventListener('click', handleShipmentLinkClick)

    return () => {
      document.body.removeEventListener('click', handleShipmentLinkClick)
    }
  }, [handleModalOpen])

  return (
    <ElectronicsVerificationBuyerModal
      show={isModalOpen}
      onClose={handleClose}
      screen={Screen.MessageList}
    />
  )
}

export default ElectronicsVerificationInfoLink
